<template>
  <div class="cascader-single">
    <el-popover popper-class="cascader-single-popper" v-model="visible" trigger="click" placement="bottom-start" :disabled="disabled">
      <div style="">
        <el-cascader-panel ref="cascader" :options="singleShowList" :props="props" v-model="checkValue" @change="tagMain($refs.cascader.getCheckedNodes())" />
      </div>
      <div slot="reference">
        <el-input class="zwx-input" :class="checkValue.length && !disabled ? 'zwx-input-close' : null" v-model="singleList" readonly :disabled="disabled" style="transition: width 2s;" :placeholder="placeholder">
          <i v-if="clearable" slot="suffix" class="el-input__icon el-icon-circle-close" @click.stop="" @click="
              checkValue = []
              inputValue = singleList = null
              visible = false
            " />
          <i slot="suffix" class="el-input__icon el-icon-arrow-down" :class="visible ? ' zwx-input-up' : ''" />
        </el-input>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'CascaderSingle',
  model: {
    prop: 'value',
    event: 'propEvent',
  },
  components: {},
  props: {
    value: { type: String, default: '' },
    codeTypeCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    clearable: { type: Boolean, default: true },
    expandTrigger: { type: String, default: 'click' },
    placeholder: { type: String, default: '请选择' },
    props: {
      type: Object,
      default() {
        return { value: 'codeNo', label: 'codeName', expandTrigger: this.expandTrigger }
      },
    },
    options: {
      type: Array,
      default() {
        return []
      },
    },
    simpleCodeList: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      api: this.$store.state.api,
      visible: false,
      singleShowList: this.options,
      singleList: '',
      zoneTypeAreaMax: 0,
      inputValue: this.value,
      checkAll: [],
      checkValue: [],
    }
  },
  created() { },
  mounted() { },
  watch: {
    inputValue(val) {
      this.$emit('propEvent', val)
    },
    value() {
      this.arr()
    },
    options(u) {
      this.singleShowList = u
    },
    simpleCodeList: {
      handler(u) {
        this.singleShowList = this.singleListFul(u, '')
        this.checkAll = u
        this.arr()
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {},
  methods: {
    //tags内容处理
    tagMain(val) {
      this.singleList = val[0].label
      this.inputValue = val[0].value
      this.visible = false
      let data = {
        label: val[0].label,
        value: val[0].value,
      }
      this.$emit('change', val[0].value)
      this.$emit('allChange', data)
    },
    arr() {
      if (this.value) {
        //临时方法，需要修改
        if (this.checkAll[0].codeTypeCode === '4011') {
          let conArr = this.checkAll.filter(e => e.standardCode === this.value)[0]
          // input 里的默认值
          this.singleList = conArr.codeName
          //cascader 的默认值
          this.checkValue = conArr.standardCode
        } else {
          let conArr = this.checkAll.filter(e => this.value.indexOf(e.codeNo) != -1)[0]
          // input 里的默认值
          this.singleList = conArr.codeName
          //cascader 的默认值
          this.checkValue = conArr.codeLevelNo.split('.')
        }
      } else {
        this.checkValue = []
        this.singleList = ''
      }
    },
    singleListFul(data, pid) {
      //递归方法 生成 json tree 数据
      var result = [],
        temp,
        obj
      data.some(e => {
        let LevelNoArr = e.codeLevelNo.split('.')
        if ((e.codeLevelNo == e.codeNo && pid == '') || LevelNoArr[LevelNoArr.length - 2] == pid) {
          obj = { ...e }
          temp = this.singleListFul(data, e.codeNo)
          if (temp.length > 0) {
            obj.children = temp
          }
          result.push(obj)
        }
      })
      return result
    },
  },
}
</script>

<style lang="less" scoped>
.cascader-single {
  font-size: 12px !important;

  .el-icon-arrow-down:before {
    content: '\e6df' !important;
  }

  .el-icon-circle-close {
    display: none !important;
  }

  .el-icon-arrow-down {
    font-size: 12px !important;
  }

  /deep/ .zwx-input-close:hover {
    .el-icon-circle-close {
      display: inline-block !important;
    }

    .el-icon-arrow-down {
      display: none !important;
    }
  }

  .zwx-input-up {
    // transform-origin: 8px 9.5px;
    transform: rotateZ(-180deg);
    margin-left: -10px;
    margin-top: -1px;
    // transform: rotate(0);
  }

  /deep/ .el-popover__reference {
    position: relative;
  }
}
</style>

<style lang="less">
.cascader-single-popper {
  padding: 0;
  margin-top: unset !important;

  .el-cascader-panel.is-bordered {
    border: none;
  }

  .el-cascader-menu {
    color: #3a485e;
  }

  .el-cascader-node__label {
    font-size: 14px !important;
    padding: 0 12px !important;
  }

  .el-cascader-node {
    height: 32px !important;
    line-height: 32px !important;
    padding: unset !important;
  }

  .el-cascader-node.in-active-path,
  .el-cascader-node.is-active,
  .el-cascader-node.is-selectable.in-checked-path {
    color: #316cf5 !important;
  }

  .el-cascader-node__prefix {
    display: none !important;
  }
}
</style>
